module.exports = __webpack_public_path__ + "static/new-zealand-c010692bb2105efcfded3662a37a0589.png";